import React from 'react';
import Logo from "../../images/logo.png"
import LogoDark from "../../images/logo-dark.png"
import Blank from "../../images/blank.png"
import Slide1 from "../../images/slider/slide-1-fw-short.jpg"
import Slide2 from "../../images/slider/slide-2-fw-short.jpg"
import WelcomeSlide from "../../images/welcome.png"

const Welcome = () => (
    <div className="wrapper">
        <div className="wrapper-inner">

            <header className="header header-absolute header-transparent header-fixed-on-mobile"
                    data-helper-in-threshold="200" data-helper-out-threshold="500" data-sticky-threshold="200"
                    data-bkg-threshold="100">
                <div className="header-inner">
                    <div className="row nav-bar">
                        <div className="column width-12 nav-bar-inner">
                            <div className="logo logo-center">
                                <div className="logo-inner">
                                    <a href="#"><img src={LogoDark} alt="흑우촌 로고"/></a>
                                    <a href="#"><img src={Logo} alt="흑우촌 로고"/></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div className="content clearfix">

                <div className="section-block window-height featured-media">
                    <div id="fws-1" className="tm-slider-container full-width-slider" data-scale-under="1140"
                         data-speed="1000">
                        <ul className="tms-slides">
                            <li className="tms-slide">
                                <img src={WelcomeSlide} style={{
                                    visibility: 'visible'
                                }} />
                            </li>
                            <li className="tms-slide" data-image data-force-fit data-animation="scaleIn"
                                data-overlay-bkg-color="#000000" data-overlay-bkg-opacity="0.3">
                                <div className="tms-content">
                                    <div className="tms-content-inner center">
                                        <div className="row">
                                            <div className="column width-12">
                                                <h3 className="tms-caption title-medium color-white mb-30"
                                                    data-animate-in="preset:scaleOut;duration:1000ms;"
                                                    data-no-scale
                                                >
                                                    This is a full width slide making use of API buttons.
                                                </h3>
                                                <div className="clear"></div>
                                            </div>
                                            <div className="column width-4 right center-on-mobile mb-mobile-10">
                                                <a className="tms-caption slider-aux-nav slider-aux-prev"
                                                   href="#"
                                                   data-animate-in="preset:slideInUpShort;duration:1000ms;delay:400ms;"
                                                   data-no-scale
                                                   data-target-slider="fws-1"
                                                >
                                                    <span className="icon-left-open-mini color-white"></span>
                                                    <span className="color-white">Prev Slide</span>
                                                </a>
                                            </div>
                                            <div className="column width-4 center mb-mobile-10">
                                                <a className="tms-caption scroll-link"
                                                   href="#content-slider"
                                                   data-animate-in="preset:slideInUpShort;duration:1000ms;delay:400ms;"
                                                   data-no-scale
                                                >
                                                    <span className="icon-down-open-mini color-white"></span>
                                                    <span className="color-white">Scroll Down</span>
                                                </a>
                                            </div>
                                            <div className="column width-4 left center-on-mobile mb-mobile-10">
                                                <a className="tms-caption slider-aux-nav slider-aux-next"
                                                   href="#"
                                                   data-animate-in="preset:slideInUpShort;duration:1000ms;delay:400ms;"
                                                   data-no-scale
                                                   data-target-slider="fws-1"
                                                >
                                                    <span className="icon-right-open-mini color-white"></span>
                                                    <span className="color-white">Next Slide</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img data-src={Slide1} data-retina src={Blank}
                                     alt=""/>
                            </li>
                            <li className="tms-slide" data-image data-force-fit data-animation="slideTopBottom"
                                data-overlay-bkg-color="#000000" data-overlay-bkg-opacity="0.3">
                                <div className="tms-content">
                                    <div className="tms-content-inner center">
                                        <div className="row">
                                            <div className="column width-12">
                                                <h3 className="title-medium font-alt-2 weight-light color-white mb-10">
                                                    <span className="tms-caption"
                                                          data-animate-in="preset:flipInY;duration:800ms;;"
                                                          data-no-scale>This is</span>
                                                    <span className="tms-caption"
                                                          data-animate-in="preset:slideInDownShort;duration:800ms;delay:300ms;"
                                                          data-no-scale>an</span>
                                                    <span className="tms-caption"
                                                          data-animate-in="preset:flipInY;duration:800ms;delay:600ms;"
                                                          data-no-scale>advanced</span>
                                                    <span className="tms-caption"
                                                          data-animate-in="preset:slideInUpShort;duration:800ms;delay:900ms;"
                                                          data-no-scale>caption</span>
                                                    <span className="tms-caption"
                                                          data-animate-in="preset:flipInX;duration:800ms;delay:1200ms;"
                                                          data-no-scale>animation</span>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img data-src={Slide2} data-retina src={Blank}
                                     alt=""/>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>

        </div>
    </div>
);

export default Welcome;